import { render, staticRenderFns } from "./ScheduleComponentCard.vue?vue&type=template&id=50b63d89&scoped=true"
import script from "./ScheduleComponentCard.vue?vue&type=script&lang=js"
export * from "./ScheduleComponentCard.vue?vue&type=script&lang=js"
import style0 from "./ScheduleComponentCard.vue?vue&type=style&index=0&id=50b63d89&prod&scoped=true&lang=css"
import style1 from "./ScheduleComponentCard.vue?vue&type=style&index=1&id=50b63d89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b63d89",
  null
  
)

export default component.exports